export default __webpack_public_path__ + "static/media/shipvista.e5ffda5e.png";